import { ECheckoutPageEvent, ESessionStorageKeys } from 'constants/enums';
import { useEffect } from 'react';
import { webStorageUtil } from 'state/webStorage.state.service';

export const useCheckoutMessageHandler = ({
  navigate,
  setActiveOrderId,
}: {
  navigate: (url: string) => void;
  setActiveOrderId: (id: string) => void;
}) => {
  useEffect(() => {
    const handleSupport = (params: any) => {
      navigate(params.supportUrl);
    };

    const handleAnimation = () => {
      const pendingOrders = webStorageUtil.get(ESessionStorageKeys.PENDING_ORDER_ID) || [];

      const sortedPendingOrders = [...pendingOrders].sort(
        (a, b) => a.completedMissionIndex - b.completedMissionIndex
      );

      if (sortedPendingOrders.length === 0) return;

      const [nextOrder, ...remainingOrders] = sortedPendingOrders;

      setActiveOrderId(nextOrder.orderId);

      const progressBarLength = Number(
        webStorageUtil.get(ESessionStorageKeys.ACTIVE_MISSIONS_LENGTH)
      );

      const isLastPendingOrder = remainingOrders.length === 0;
      const isLastMission = progressBarLength - 1 === nextOrder.completedMissionIndex;

      const delay = isLastPendingOrder ? (isLastMission ? 4000 : 3000) : 0;

      setTimeout(() => {
        webStorageUtil.set(ESessionStorageKeys.PENDING_ORDER_ID, remainingOrders);

        if (isLastPendingOrder && isLastMission) {
          webStorageUtil.set(ESessionStorageKeys.ACTIVE_MISSIONS_LENGTH, 0);
        }
      }, delay);
    };

    const eventHandler = (massageEvent: any) => {
      if (massageEvent.origin !== window.location.origin) return;

      const { params, event } = massageEvent.data;

      switch (event) {
        case ECheckoutPageEvent.SUPPORT:
          handleSupport(params);
          break;

        case ECheckoutPageEvent.POINTS_ANIMATION_DONE:
        case ECheckoutPageEvent.REWARD_ANIMATION_DONE:
          handleAnimation();
          break;

        default:
          break;
      }
    };

    window.addEventListener('message', eventHandler);

    return () => {
      window.removeEventListener('message', eventHandler);
    };
  }, [navigate, setActiveOrderId]);
};
